import factory from '../../../store/factory'

export default {
  mailcast: factory('Mailcast'),
}